import React, { useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import Header from "../Components/Header";
import NavBar from "../Components/NavBar";
import useAuth from "../useAuth";

export default function EntryPage() {
  const { user } = useAuth();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  if (!user) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="flex flex-col h-screen bg-resq-resqBg font-outfit overflow-hidden">
      {/* Top Header - Full Corner to Corner */}
      <Header isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />

      <div className="flex flex-1 min-h-0 overflow-hidden relative">
        {/* Sidebar Navigation - Below Header */}
        <NavBar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />

        {/* Main Content Area */}
        <main className="flex-1 overflow-y-auto px-4 pt-1 pb-4 md:px-8 md:pt-2 md:pb-8 fancy-scrollbar bg-[#F8FAFC]">
          <div className="max-w-[1600px] mx-auto w-full animate-in fade-in slide-in-from-bottom-4 duration-700">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}


